/**
 * @sw-package checkout
 */
// Register them via the existing PluginManager
const PluginManager = window.PluginManager;

PluginManager.register(
    'SubscriptionProductBox',
    () => import('./plugin/subscription-product-box.plugin'),
    '[data-subscription-product-box]',
);

PluginManager.register(
    'SubscriptionInputSyncer',
    () => import('./plugin/subscription-input-syncer.plugin'),
    '[data-subscription-input-syncer]',
);
